module.exports = {"href":"/corgi/pageapps/prepurchase/_next/public/sprite-7.27.0-de48ae84e.svg#star-empty","viewBox":"0 0 18.5 17.69"}